import _Abstract from "system/abstract"

export default class ContactFormKenticoLoading  {

    constructor()
    {
        if(typeof window['Sys'] === 'undefined' || typeof window['Sys']['WebForms'] === 'undefined' || typeof window['Sys']['WebForms']['PageRequestManager'] === 'undefined')
        {
            console.error('Kentico Web Forms JavaScript not found (Currently running outside of kentico?)');
            return;
        }

        if($('.FormPanel').length === 0)
        {
            //more than one form panel on the page
            console.error('Error: No form panels found on page');
            return;
        }


        if($('.FormPanel').length > 1)
        {
            //more than one form panel on the page
            console.error('Error: More than one form panel found on page');
            return;
        }
        this.initialiseListeners(); 
    }

    initialiseListeners()
    {
        
        var pageRequestManager = Sys.WebForms.PageRequestManager.getInstance();
        pageRequestManager.add_pageLoaded( this.onPageLoaded.bind(this) );

        if (!pageRequestManager.get_isInAsyncPostBack())
        {
            pageRequestManager.add_beginRequest(this.beginRequest.bind(this));
            pageRequestManager.add_endRequest(this.endRequest.bind(this));
        }
    }

    beginRequest(sender, args)
    {
        var $submitButton = $('.FormPanel input[type="submit"]');
        $submitButton.hide();
        $submitButton.parent().css('position','relative');
        var htmlLoader = "<div class='-loading -loader-wrapper -loading-inline -no-colour-loading-bg'><div class='uil-spin-css -white'><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div></div></div>";
        $submitButton.parent().append(htmlLoader);
    }

    endRequest(sender, args)
    {
        var $submitButton = $('.FormPanel input[type="submit"]');
        $submitButton.show();
        $submitButton.parent().find('.-loading-wrapper').remove();
    }

    onPageLoaded( sender, args )
    {
        
    }
}



/** WEBPACK FOOTER **
 ** ./system/contact-form-kentico-loading.js
 **/